import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import { apiRoot } from "../consts";

export const useNewApi = true;

export async function fetchData({ queryKey }: any) {
  const [path] = queryKey;
  const url = apiRoot + path;

  try {
    const result = await axios(url, {
      withCredentials: true,
    });

    if (result.status !== 200) {
      throw new Error("Network response was not ok");
    }

    return result.data;
  } catch (error) {
    throw new Error("Network error " + path + " " + error);
  }
}

export const useDataQuery = <T = any>(
  path: string,
  skip = false,
  defaultValue = null,
) => {
  const fn = skip ? () => Promise.resolve(defaultValue) : fetchData;
  //  const fn = fetchData;
  const { data } = useQuery<T>({
    queryKey: [path],
    queryFn: fn,

    staleTime: 5 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: 1,
    gcTime: 5 * 60 * 1000,
  });

  return data;
};

export const useDataQueryRefetch = <T = any>(
  path: string,
  skip = false,
  defaultValue = null,
) => {
  const fn = skip ? () => Promise.resolve(defaultValue) : fetchData;
  // const fn = fetchData;
  const { data, refetch } = useQuery<T>({
    queryKey: [path],
    queryFn: fn,

    staleTime: 5 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: 1,
    gcTime: 5 * 60 * 1000,
  });

  return { data, refetch };
};
